// dependencies
import { List, Map, fromJS } from "immutable";

const initialState = Map({
	goalCategoryCount: 0,
	authentication: Map(), // authentication settings
	directoryFields: List(), // the colums used on the directory
	performyardFields: List(),
});

export default function invitation(state = initialState, action) {
	switch (action.type) {
		case "COMPANY:UPDATE":
			return state.setIn(action.keyPath, action.value);

		case "COMPANY:GOALCATEGORIES.COUNT@SUCCESS": {
			return state.setIn(["goalCategoryCount"], action.response.get("count", 0));
		}

		case "COMPANY:FIELDS@SUCCESS": {
			// Match fields based on field.id. Add all new fields, if a field already exists, keep the new one. Keep any old fields with ids not in the list.
			const newFields = action.response;
			const newFieldIDs = newFields.map((field) => field.get("id"));
			const oldFields = state.get("performyardFields");
			const oldFieldsToKeep = oldFields.filter((field) => !newFieldIDs.includes(field.get("id")));
			// If we don't use fromJS, this causes errors in the Field Matching selectors.
			const fieldsToAdd = fromJS([...newFields, ...oldFieldsToKeep]);

			return state.setIn(["performyardFields"], fieldsToAdd);
		}

		case "COMPANY:RESETFIELDS": {
			return state.setIn(["performyardFields"], List());
		}

		case "SETTINGS:GETCOMPANY@SUCCESS": {
			const { response } = action;
			const authenticationSettings = response.get("authentication", Map());

			return state.setIn(["authentication"], fromJS(authenticationSettings));
		}

		default:
			return state;
	}
}
